import { useState, useEffect } from 'react';
import request from '../../utils/request';
import TableSearch from '../common/TableSearch';
import loader from '../common/loader.gif';
import Button from '@mui/material/Button';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import DeleteAlert from '../common/DeleteAlert';
import { checkPermission } from '../../utils/permission';
import PersonAddAlt1 from '@mui/icons-material/PersonAddAlt1';
import {
  Tooltip,
  Divider,
  Box,
  Card,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableContainer,
  Typography,
  useTheme,
  Switch,
  Grid,
  Chip
} from '@mui/material';
import { useFormik } from 'formik';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from 'react-router-dom';
import BreadCrumbV2 from '../common/BreadCrumbV2';
import SnackbarAlert from '../common/SnackbarAlert';
import PageHeader from '../common/PageHeader';
import Breadcrumbs from '../common/BreadCrumb';
import ClosedCaptionIcon from '@mui/icons-material/ClosedCaption';
import SelectCompany from './SelectCompany';
import NoPermissionMessage from '../common/NoPermissionMessage';
import TableSearchWithIcon from '../common/TableSearchWithIcon';

const PolicyBrokerageList = ({
  setEditProdComDatas,
  showCreateEditForm,
  showCreateEdit
}) => {
  const [isLoading, setLoading] = useState(true);
  const theme = useTheme();
  const [policyBrokerageDatas, setPolicyBrokerageDatas] = useState<any>([]);
  const [offset, setOffset] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalCount, setTotalCount] = useState<number>(0);
  interface SearchState {
    text: string;
    triggerId: number;
  }
  const [search, setSearch] = useState<SearchState>({
    text: '',
    triggerId: Date.now(),
  });
  const [companybranchState, setCompanyBranchState] = useState<any>([]);
  const [deleteopen, setDeleteOpen] = useState(false);
  const [deleteData, setDeleteData] = useState<any>([]);
  const [showModal, setShowModal] = useState(false);

  const [policyProductDatas, setPolicyProductDatas] = useState<any>([]);
  const [policyBrokerageCreatePermission, setPolicyBrokerageCreatePermission] =
    useState(false);
  const [policyBrokerageUpdatePermission, setPolicyBrokerageUpdatePermission] =
    useState(false);
  const [insuranceCompanyPermission, setInsuranceCompanyPermission] =
    useState(false);
  const [comProdDeletePermission, setComProdDeletePermission] =
    useState(false);


  // const [policyBrokerageDeletePermission, setPolicyBrokerageDeletePermission] =
  //   useState(false);
  const routeArray = window.location.pathname.split('/');
  // formik.initialValues.companyId = parseInt(routeArray[3]);
  const handleDeleteOpen = (data) => {
    setDeleteData(data);
    setDeleteOpen(true);
  };

  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });

  const handleChangePage = (event, newPage) => {
    setOffset(newPage);
    getPolicyBrokerageDatas();
  };

  const addBrokerageClause = (data) => {
    setEditProdComDatas(data);
    showCreateEditForm();
  };

  useEffect(() => {
    getPolicyDatas();
  }, []);
  const getPolicyDatas = async () => {
    request({
      url: 'policyProduct/getPolicyProductById',
      method: 'post',
      data: {
        id: parseInt(routeArray[3])
      }
    }).then(
      (response) => {
        setPolicyProductDatas([]);
        setPolicyProductDatas(response);
      },
      (error) => {
        console.log(error);
      }
    );
  };
  const handleChange = (editDatas) => {
    request({
      url: 'productCompanyConfiguration/updateBrokerageProdCmpStatus',
      method: 'put',
      data: {
        id: editDatas.id,
        status: !editDatas.status
      }
    })
      // eslint-disable-next-line
      .then((response) => {
        // getPolicyDatas();
        setShowSnackBarAlert({
          status: true,
          type: 'success',
          message: 'Policy Product status updated'
        });
        getPolicyBrokerageDatas();
      })
      .catch(function (err) {
        getPolicyDatas();
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message
        });
      });
  };

  const handleChangeRowsPerPage = (event) => {
    console.log(event.target.value);
    setRowsPerPage(+parseInt(event.target.value));
    setOffset(0);
    getPolicyBrokerageDatas();
  };

  const changeSearch = (searchValue) => {
    console.log(searchValue);
    setOffset(0);
    setSearch(searchValue);
    // getCompanyBranchDatas();
  };

  const openSelectCompany = () => {
    setShowModal(true);
  };

  const CloseSelectCompany = () => {
    getPolicyBrokerageDatas();
    setShowModal(false);
  };

  useEffect(() => {
    getPolicyBrokerageDatas();
  }, [rowsPerPage, offset, search]);
  const getPolicyBrokerageDatas = async () => {
    request({
      url: 'productCompanyConfiguration/getBrokerageProdCmpList',
      method: 'post',
      data: {
        search:search?.text,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: offset,
        limit: rowsPerPage,
        productId: parseInt(routeArray[3])
      }
    }).then(
      (response) => {
        setPolicyBrokerageDatas([]);
        setPolicyBrokerageDatas(response['prodComBrokage']);

        setTotalCount(0);
        setTotalCount(response['prodComBrokageCount']);
        setLoading(false);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const [open, setOpen] = useState(false);

  const handleOpen = (policyBrokerage) => {
    setCompanyBranchState(policyBrokerage);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  const refetchApi = () => {
    getPolicyBrokerageDatas();
  };

  useEffect(() => {
    checkRolePermission();
    checkeUStatusChangeRolePermission();
    checkeInsuranceCompanyRolePermission();
    checkDeleteRolePermission();
  }, []);

  const checkRolePermission = async () => {
    await checkPermission('brokerageCalculation', 'compProdLink').then(
      (permission) => {
        setPolicyBrokerageCreatePermission(permission);
      }
    );
  };

  const checkeUStatusChangeRolePermission = async () => {
    await checkPermission('brokerageCalculation', 'statusChange').then(
      (permission) => {
        setPolicyBrokerageUpdatePermission(permission);
      }
    );
  };

  const checkeInsuranceCompanyRolePermission = async () => {
    await checkPermission('InsuranceCompany', 'View').then((permission) => {
      setInsuranceCompanyPermission(permission);
    });
  };

  const checkDeleteRolePermission = async () => {
    await checkPermission('brokerageCalculation', 'deleteCompProd').then((permission) => {
      setComProdDeletePermission(permission);
    });
  };

  return (
    <>
      <BreadCrumbV2
        breadCrumbLinks={[
          {
            name: 'Policy Product',
            link: '/dashboards/policyProducts'
          },
          {
            name: 'Policy Products Brokerage',
            link: '#'
          }
        ]}
      />
      {/* )} */}
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Card>
        <Typography>
          <Typography mt={1} color="text.secondary" sx={{ color: '#5569ff' }}>
            <strong>&nbsp; Policy Name : {policyProductDatas.name}</strong>{' '}
            &nbsp; &nbsp;
            <Tooltip title="Policy Code" arrow>
              <Chip
                icon={<ClosedCaptionIcon />}
                label={policyProductDatas.code}
              />
            </Tooltip>
            &nbsp;&nbsp;
          </Typography>
          &nbsp;&nbsp;
        </Typography>
      </Card>
      &nbsp; &nbsp;
      <Card>
        <Grid container mt={1} mb={1} mr={1} ml={1}>
          {policyBrokerageCreatePermission ? (
            <>
              {insuranceCompanyPermission ? (
                <Grid item xs={8}>
                  <PageHeader
                    title={'Policy Brokerage Details'}
                    button_text={'Create Brokerage'}
                    showCreateEditForm={openSelectCompany}
                  // showCreateEditForm={showCreateEditForm}
                  />
                </Grid>
              ) : (
                <Grid item xs={8}>
                  <Grid item xs={8}>
                    <h3>Policy Brokerage Details</h3>
                    <NoPermissionMessage
                      message={
                        'You do not have permission to access the Insurance company list'
                      }
                    />
                  </Grid>

                </Grid>
              )}
            </>
          ) : (
            <Grid item xs={8}>
              <Grid item xs={8}>
                <h3>Policy Brokerage Details</h3>
              </Grid>
              {/* <NoPermissionMessage
           message={'You do not have permission to access the Insurance company list'}
           /> */}
            </Grid>
          )}

          <Grid item xs={4}>
            <TableSearchWithIcon changeSearch={changeSearch} deafultSearchValue={search?.text} />
          </Grid>
        </Grid>

        <Divider />
        {isLoading ? (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    <img
                      alt="loader"
                      src={loader}
                      className="loader"
                      width={100}
                      height={100}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Product Name</TableCell>

                  <TableCell>Company Name</TableCell>

                  {policyBrokerageUpdatePermission ? (
                    <TableCell>Status</TableCell>
                  ) : null}

                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {policyBrokerageDatas.map((data) => {
                  return (
                    <TableRow hover key={data.id}>
                      <TableCell>
                        <Typography
                          variant="body1"
                          fontWeight="bold"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        ></Typography>
                        {data.product?.name}
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="body1"
                          fontWeight="bold"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        ></Typography>
                        {data.company?.name}
                      </TableCell>

                      {policyBrokerageUpdatePermission ? (
                        <TableCell align="left">
                          <Switch
                            checked={data.status}
                            inputProps={{ 'aria-label': 'controlled' }}
                            onChange={() => handleChange(data)}
                          />
                        </TableCell>
                      ) : null}

                      <TableCell>
                        {/* {policyProductUpdatePermission ? ( */}
                        <Tooltip title="Edit/Add Brokerage" arrow>
                          <IconButton
                            sx={{
                              '&:hover': {
                                background: theme.colors.primary.lighter
                              },
                              color: theme.palette.primary.main
                            }}
                            color="inherit"
                            size="small"
                            // showCreateEditForm={showCreateEditForm}
                            onClick={() => addBrokerageClause(data)}
                          >
                            <EditTwoToneIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        {/* ) : null} */}
                        {comProdDeletePermission ? (
                          <Tooltip title={`Delete Product Brokerage`} arrow>
                            <IconButton
                              sx={{
                                '&:hover': {
                                  background: theme.colors.error.lighter
                                },
                                color: theme.palette.error.main
                              }}
                              color="inherit"
                              size="small"
                              onClick={() => handleDeleteOpen(data)}
                            >
                              <DeleteTwoToneIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        ) : null}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <DeleteAlert
          pageContent={'Policy Brokerages'}
          deleteopen={deleteopen}
          deleteName={deleteData.company?.name}
          deleteData={deleteData}
          refetchApi={refetchApi}
          setDeleteOpen={setDeleteOpen}
          apiUrl={'productCompanyConfiguration/' + deleteData.id}
        />

        <Box p={2}>
          <TablePagination
            rowsPerPageOptions={[25, 50, 75, 100]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={offset}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </Card>
      <SelectCompany
        showModal={showModal}
        closeModal={CloseSelectCompany}
        policyProductData={policyProductDatas}
      ></SelectCompany>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Policy Brokerage Details'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus variant="contained" color='primary'>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PolicyBrokerageList;
